import { z } from 'zod'

export const paramsSchema = z.object({
  facetSlug: z.string(),
  searchListType: z.enum(['list', 'facet', 'results']),
  page: z.number(),
})

export type paramsType = z.infer<typeof paramsSchema>
